import { CoOwner, Encumbrance, ScriptureData } from 'types';

type Props = {
  encumbrances: Encumbrance[];
  encumbranceName: string;
  encumbranceDate: string;
  encumbranceEndDate: string;
  encumbranceFrom: number;
  encumbranceTo: number;
  encumbranceScriptureData: ScriptureData;
  encumbranceFile: File | undefined;
  coOwners: CoOwner[];
};

export default function addEncumbrance({
  encumbrances,
  encumbranceName,
  encumbranceDate,
  encumbranceEndDate,
  encumbranceFrom,
  encumbranceTo,
  encumbranceScriptureData,
  encumbranceFile,
  coOwners,
}: Props) {
  const newEncumbrances = [
    ...encumbrances,
    {
      name: encumbranceName,
      from: encumbranceFrom,
      to: encumbranceTo,
      date: encumbranceDate,
      endDate: encumbranceEndDate,
      scriptureData: encumbranceScriptureData,
      scriptureDocument: '',
      file: encumbranceFile,
      coOwners,
    },
  ];

  return newEncumbrances;
}
